export default {
  actions: {
    async getNews(ctx, data) {
      axios
        .get(data.path + `/getNews?limit=${data.limit}`)
        .then(response => {
          const news = response.data;

          ctx.commit('updateNews', news)
        })
    },
    getPostBySlug(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(data.path + `/newsBySlug/${data.slug}`)
          .then(response => {
            resolve(response.data);
          }).catch(e => {
          reject(e);
        });
      });
    },
    getPreviewBySlug(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(data.path + `/previewNews/${data.slug}`, {headers: {Authorization: 'Bearer ' + data.token}})
          .then(response => {
            resolve(response.data);
          }).catch(e => {
          window.location.href = '/';
          reject(e);
        });
      });
    },
  },
  mutations: {
    updateNews(state, news) {
      state.news = news
    },
  },
  state: {
    news: [],
  },
  getters: {
    allNews(state) {
      return state.news
    },
  }
}
